<template>

<div>
  Hello world
</div>

</template>

<script>
import axios from 'axios'

export default {
  methods: {
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    resetError(){
      clearTimeout(this.errorTimeOUt)
      this.errorTimeOUt = setTimeout(x=>{ this.error = null }, 4000)
    },
    goTo(path) {
      this.$router.push(path)
    },
  },
  async created(){
    return new Promise(async (res, rej) => {
      const token = this.$route.query.token

      if (!token) {
        this.$router.push('/home')
      }

      const fireapi = "https://aramccogermany-eins.com/back/public/api"

      let r = await axios.post(`${fireapi}/v1/qrcodelogin`, {auth_token: token}).then(x=>x.data)
      
      if(!r.error) {
        this.$store.state.centralLogin = true
        this.$store.state.access_token = r.access_token
        this.setCookie('_EVINNO', r.access_token, 1)
        this.$store.state.user = r.user
        localStorage.type = r.user.type
        if(r.user && r.user.role == 'admin')  {
          this.goTo('/dashboard')
        } else if(r.user && r.user.role == 'superadmin')  {
          this.goTo('/dashboard')
        } else {
          this.goTo('/dashboard')
        }
        try {
          gtag('event', `login_success`);
          gtag('event', `login_success_${r.user.uuid}`);
        } catch (error) {
          // console.log(error)
        }
      } else if (r.error == 'unuthorized_access') {
        this.$emit('snackbarNotification', `${this.i18n.accountCreated}`, 'error')
        this.error = this.i18n.accountCreated
        this.resetError()
      } else {
        this.$emit('snackbarNotification', `${r.error}`, 'error')
        this.error = r.error
        this.resetError()
      }
      console.log(r.access_token); 

      res(true)
    })
  }
}
</script>